export const DownloadAltIcon = ({ color = "#DBBE78", size = 12, ...props }) => (
    <svg width={size} height={size * (16 / 12)} viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M11.5256 5.63431H7.84158V2.81716V0H4.15761V2.81716V5.63431H0.473633L5.99959 12.2077L11.5256 5.63431ZM0.473633 14.0858V15.9639L11.5256 16V15.0609V14.1219L0.473633 14.0858Z"
            fill={color}
        />
    </svg>
);
